import { MovieIcon } from '@icon/movie-icon';
import { TvSeriesIcon } from '@icon/tv-series-icon';
import { ContentType } from '@lib/content';
import { Card, CardContent, Grid, Box, Typography } from '@material-ui/core';
import {
  amber,
  blue,
  cyan,
  green,
  grey,
  indigo,
  orange,
  pink,
  purple,
  red,
  teal,
} from '@material-ui/core/colors';
import { createControlField } from '@lib/common';
import clsx from 'clsx';
import styled from 'styled-components';
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
import CastIcon from '@material-ui/icons/Cast';
import SportsEsportsIcon from '@material-ui/icons/SportsEsports';
import BusinessIcon from '@material-ui/icons/Business';
import BookIcon from '@material-ui/icons/Book';
import MenuBookIcon from '@material-ui/icons/MenuBook';
import MicroSeriesIcon from '../../../../assets/icons/micro-series.svg';
import FormatIcon from '../../../../assets/icons/formats.svg'
import IPIcon from '../../../../assets/icons/IP-icon-new.svg'

const ContentTypePicker = ({ value, onChange = null }) => {
  return (
    <ContentPickerStyles>
      <Box p={1} style={{ background: '#f5f5f5' }}>
        <Grid container spacing={3}>
          <Grid item xs={6}>
            <Card
              onClick={onChange && (() => onChange(ContentType.SERIES))}
              className={clsx('card-button tv', { selected: value === ContentType.SERIES })}>
              <CardContent>
                <Grid container spacing={1} alignItems="center">
                  <Grid item>
                    <TvSeriesIcon style={{ fontSize: '2.25rem' }} />
                  </Grid>
                  <Grid item>
                    <Typography className="title" variant="h6">
                      TV Series
                    </Typography>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={6}>
            <Card
              onClick={onChange && (() => onChange(ContentType.MOVIE))}
              className={clsx('card-button movie', { selected: value === ContentType.MOVIE })}>
              <CardContent>
                <Grid container spacing={1} alignItems="center">
                  <Grid item>
                    <MovieIcon style={{ fontSize: '2.25rem' }} />
                  </Grid>
                  <Grid item>
                    <Typography className="title" variant="h6">
                      Movie
                    </Typography>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
        <br />
        <Grid container spacing={3}>
          <Grid item xs={6}>
            <Card
              onClick={onChange && (() => onChange(ContentType.MICROSERIES))}
              className={clsx('card-button micro-series', {
                selected: value === ContentType.MICROSERIES,
              })}>
              <CardContent>
                <Grid container spacing={2} alignItems="center">
                  <Grid item>
                   {/*  <img
                     // src="/images/micro-series.svg"
                      src={MicroSeriesIcon}
                      loading="eager"
                      decoding="async"
                      style={{ height: '35px', marginLeft: '5px', marginTop: '5px' }}
                    /> */}
                     <img
                     src="/images/micro-series.png"
                     // src={MicroSeriesIcon}
                      loading="eager"
                      decoding="async"
                      style={{ height: '35px', marginLeft: '5px', marginTop: '5px' }}
                    />
                  </Grid>
                  <Grid item>
                    <Typography className="title" variant="h6">
                      Micro-Series
                    </Typography>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={6}>
            <Card
              onClick={onChange && (() => onChange(ContentType.FORMAT))}
              className={clsx('card-button game', { selected: value === ContentType.FORMAT })}>
              <CardContent>
                <Grid container spacing={2} alignItems="center">
                  <Grid item>
                  {/*   <img
                     // src="/images/formats.svg"
                      src={FormatIcon}
                      loading="eager"
                      decoding="async"
                      style={{ height: '35px', marginLeft: '5px', marginTop: '5px' }}
                    /> */}
                    <img
                      src="/images/formats.png"
                      //src={FormatIcon}
                      loading="eager"
                      decoding="async"
                      style={{ height: '35px', marginLeft: '5px', marginTop: '5px' }}
                    />
                  </Grid>
                  <Grid item>
                    <Typography className="title" variant="h6">
                      Format
                    </Typography>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={6}>
            <Card
              onClick={onChange && (() => onChange(ContentType.BOOK))}
              className={clsx('card-button book', { selected: value === ContentType.BOOK })}>
              <CardContent>
                <Grid container spacing={2} alignItems="center">
                  <Grid item>
                    <MenuBookIcon style={{ fontSize: '2.25rem' }} />
                  </Grid>
                  <Grid item>
                    <Typography className="title" variant="h6">
                      Book
                    </Typography>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={6}>
            <Card
              onClick={onChange && (() => onChange(ContentType.PODCAST))}
              className={clsx('card-button podcast', { selected: value === ContentType.PODCAST })}>
              <CardContent>
                <Grid container spacing={2} alignItems="center">
                  <Grid item>
                    <CastIcon style={{ fontSize: '2.25rem' }} />
                  </Grid>
                  <Grid item>
                    <Typography className="title" variant="h6">
                      Podcast
                    </Typography>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
        <br />
        <Grid container spacing={3}>
          <Grid item xs={6}>
            <Card
              onClick={onChange && (() => onChange(ContentType.GAME))}
              className={clsx('card-button game', { selected: value === ContentType.GAME })}>
              <CardContent>
                <Grid container spacing={2} alignItems="center">
                  <Grid item>
                    <SportsEsportsIcon style={{ fontSize: '2.25rem' }} />
                  </Grid>
                  <Grid item>
                    <Typography className="title" variant="h6">
                      Game
                    </Typography>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={6}>
            <Card
              onClick={onChange && (() => onChange(ContentType.STORY))}
              className={clsx('card-button story', { selected: value === ContentType.STORY })}>
              <CardContent>
                <Grid container spacing={2} alignItems="center">
                  <Grid item>
                    <BookIcon style={{ fontSize: '2.2rem' }} />
                  </Grid>
                  <Grid item>
                    <Typography className="title" variant="h6">
                      Story/Script
                    </Typography>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={6}>
            <Card
              onClick={onChange && (() => onChange(ContentType.IP))}
              className={clsx('card-button ip', { selected: value === ContentType.IP })}>
              <CardContent>
                <Grid container spacing={2} alignItems="center">
                  <Grid item>
                  {/*   <img
                      // src={'/images/IP-rev.svg'}
                      src={IPIcon}
                      loading="eager"
                      decoding="async"
                      style={{ height: '35px', marginLeft: '5px', marginTop: '5px' }}
                    /> */}
                     <img
                      src={'/images/IP-rev.png'}
                      loading="eager"
                      decoding="async"
                      style={{ height: '35px', marginLeft: '5px', marginTop: '5px' }}
                    />
                  </Grid>
                  <Grid item>
                    <Typography className="title" variant="h6">
                      IP
                    </Typography>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </ContentPickerStyles>
  );
};

const ContentPickerStyles = styled.div`
  .MuiCardContent-root:last-child {
    padding-bottom: 5px !important;
  }
  .MuiCardContent-root {
    padding: 5px !important;
  }
  .card-button {
    cursor: pointer;
    &:hover {
      background: #fafafa;
    }
  }
  .selected {
    .title {
      color: white;
    }
    &.tv {
      background: ${green[700]};
    }
    &.movie {
      background: ${blue[700]};
    }
    &.book {
      background: ${cyan[700]};
    }
    &.podcast {
      background: ${grey[700]};
    }
    &.game {
      background: ${amber[700]};
    }
    &.format {
      background: ${purple[700]};
    }
    &.story {
      background: ${orange[700]};
    }
    &.ip {
      background: ${teal[700]};
    }
    &.micro-series {
      background: ${pink[700]};
    }
  }
`;
export const ContentTypeField = createControlField(ContentTypePicker, null);
